<template>
  <transition name="slide-down">
    <div v-if="isOffline" class="offline-banner">
      <div class="offline-content">
        <svg class="offline-icon" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11 4a1 1 0 10-2 0v4a1 1 0 102 0V7zm-3 1a1 1 0 10-2 0v3a1 1 0 102 0V8zM8 9a1 1 0 00-2 0v2a1 1 0 102 0V9z" clip-rule="evenodd"/>
        </svg>
        <div class="offline-text">
          <strong>Você está offline</strong>
          <span>Suas alterações serão sincronizadas quando a conexão for restabelecida</span>
        </div>
      </div>
      <button @click="retry" class="btn-retry" title="Tentar reconectar">
        <svg viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clip-rule="evenodd"/>
        </svg>
      </button>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ComponentOfflineBanner',
  data() {
    return {
      isOffline: !navigator.onLine
    }
  },
  mounted() {
    window.addEventListener('offline', this.handleOffline)
    window.addEventListener('online', this.handleOnline)
  },
  beforeUnmount() {
    window.removeEventListener('offline', this.handleOffline)
    window.removeEventListener('online', this.handleOnline)
  },
  methods: {
    handleOffline() {
      this.isOffline = true

      this.$eventbus.emit("ComponentToast/add", {
        autoHide: false,
        content: "Você está offline. Verifique sua conexão com a internet.",
        showCloseButton: true,
        type: "error",
      })
    },

    handleOnline() {
      this.isOffline = false

      this.$eventbus.emit("ComponentToast/add", {
        autoHide: true,
        content: "Conexão restabelecida! Sincronizando dados...",
        type: "success",
      })

      // Trigger any pending sync operations
      this.$eventbus.emit("App/online")
    },

    retry() {
      // Force a connection check
      fetch(window.location.origin + '/manifest.json', { method: 'HEAD', cache: 'no-store' })
        .then(() => {
          if (navigator.onLine) {
            this.handleOnline()
          }
        })
        .catch(() => {
          this.$eventbus.emit("ComponentToast/add", {
            autoHide: true,
            content: "Ainda sem conexão. Tente novamente em alguns instantes.",
            type: "warning",
          })
        })
    }
  }
}
</script>

<style scoped>
.offline-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: linear-gradient(135deg, #f44336 0%, #e53935 100%);
  color: white;
  padding: 1em 1.5em;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.offline-content {
  display: flex;
  align-items: center;
  gap: 1em;
  max-width: 1200px;
  margin: 0 auto;
}

.offline-icon {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  animation: pulse 2s ease-in-out infinite;
}

.offline-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25em;
}

.offline-text strong {
  font-size: 1em;
  font-weight: 600;
}

.offline-text span {
  font-size: 0.9em;
  opacity: 0.95;
}

.btn-retry {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 0.5em 1em;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 0.5em;
  font-size: 0.9em;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-retry:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
}

.btn-retry svg {
  width: 16px;
  height: 16px;
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
}

.slide-down-enter-from {
  transform: translateY(-100%);
  opacity: 0;
}

.slide-down-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}

@media (max-width: 767px) {
  .offline-banner {
    padding: 0.875em 1em;
  }

  .offline-text span {
    display: none;
  }

  .btn-retry {
    padding: 0.5em;
  }

  .btn-retry svg {
    width: 20px;
    height: 20px;
  }
}
</style>
